import styles from "../../styles/proposal/ClaimGuide.module.css";
import classNames from "classnames/bind";
import data from "../../data/claimGuide.json";

const cx = classNames.bind(styles);

export default function ClaimGuide() {
  return (
    <div className={cx("containerWrapper")}>
      <div className={cx("pageHeader")}>
        <div className={cx("title")}>
          <h4>{data.header.title}</h4>
          <p className={cx("subtitle")}>{data.header.subtitle}</p>
        </div>
      </div>

      <div className={cx("reveal")}>
        <div className={cx("introBox", "box")}>
          <div className={cx("introContent")}>
            {data.intro.split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </div>
        </div>

        <div className={cx("stepGrid")}>
          {data.steps.map((step, idx) => (
            <div key={idx} className={cx("stepCard", "card", "liftUp")}>
              <div className={cx("stepNumber")}>{step.step}</div>
              <div className={cx("stepCardLabel")}>{step.title}</div>
              <div className={cx("stepCardText")}>{step.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
